<template>
  <div class="catalog-skeleton__variants-grid">
    <div v-for="i in 4" :key="i" class="variant-card-skeleton">
      <div class="variant-card-skeleton__image-wrapper">
        <v-skeleton-loader
          type="image"
          height="140"
          class="variant-card-skeleton__image" />
        <div class="variant-card-skeleton__indicator" />
      </div>
      <div class="variant-card-skeleton__content">
        <v-skeleton-loader
          type="text"
          width="85%"
          class="variant-card-skeleton__title" />
        <v-skeleton-loader
          type="text"
          width="65%"
          height="24"
          class="variant-card-skeleton__price" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VariantsSkeletonLoader',
}
</script>

<style scoped>
.catalog-skeleton__variants-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 1rem;
}

.variant-card-skeleton {
  width: 11.25rem;
  height: 17.75rem;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: white;
}

.variant-card-skeleton__image-wrapper {
  position: relative;
  width: 100%;
  height: 8.75rem;
}

.variant-card-skeleton__image {
  width: 100%;
  height: 100%;
  border-radius: 0;
}

.variant-card-skeleton__indicator {
  position: absolute;
  top: 0.375rem;
  right: 0.375rem;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.1);
}

.variant-card-skeleton__content {
  padding: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex: 1;
}

.variant-card-skeleton__title {
  margin-bottom: 0;
}

.variant-card-skeleton__price {
  margin-top: 0;
}
</style>
